import * as React from 'react';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';

export const BannedVideo = compose<TranslateProps, {}>(
    translate(),
)(props =>
    <div className="banned-video">
        { props.t('1371') }
    </div>
);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/BannedVideo.tsx